const SUPABASE_ICONS = "https://bqvtedneuaozpgcgcxow.supabase.co/storage/v1/object/public/media/Icons";

export const ICON_URLS = {
  salesforce: `${SUPABASE_ICONS}/salesforce.icon.a1.svg`,
  // Local asset until mercury.icon.a1.svg is uploaded to Supabase Storage.
  mercury: "/branding/mercury-os/mercury-icon.svg",
  hubspot: `${SUPABASE_ICONS}/hubspot.icon.a1.svg`,
  slack: `${SUPABASE_ICONS}/slack.icon.a1.svg`,
  gmail: `${SUPABASE_ICONS}/gmail.icon.a1.svg`,
  gcal: `${SUPABASE_ICONS}/gcal.icon.a1.svg`,
  gong: `${SUPABASE_ICONS}/gong.icon.a1.png`,
  zendesk: `${SUPABASE_ICONS}/zendesk.icon.a1.svg`,
  // NOTE: gdoc asset is named gdoc.a1.svg (not gdoc.icon.a1.svg) — differs
  // from the {name}.icon.a1.{ext} convention used by the other icons.
  gdoc: `${SUPABASE_ICONS}/gdoc.a1.svg`,
} as const;

const SUPABASE_GRAPHICS = "https://bqvtedneuaozpgcgcxow.supabase.co/storage/v1/object/public/media/Graphics";

export const GRAPHIC_URLS = {
  missionControl: `${SUPABASE_GRAPHICS}/MissionControl.svg`,
} as const;
